export enum UserStatus {
  Active = 1,
  Blocked = 0,
}
